<template>
  <div class="header-catalog">
    <a :href="urlLanguagePrefix + '/catalog/'" class="header-catalog__title">
      <span class="header-catalog__icon">
        <svg width="20"
             height="20"
             viewBox="0 0 20 20"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.13793 6.55172C5.47103 6.55172 6.55172 5.47103 6.55172 4.13793C6.55172 2.80483 5.47103 1.72414 4.13793 1.72414C2.80483 1.72414 1.72414 2.80483 1.72414 4.13793C1.72414 5.47103 2.80483 6.55172 4.13793 6.55172ZM4.13793 8.27586C6.42325 8.27586 8.27586 6.42325 8.27586 4.13793C8.27586 1.85261 6.42325 0 4.13793 0C1.85261 0 0 1.85261 0 4.13793C0 6.42325 1.85261 8.27586 4.13793 8.27586Z"
                fill="#FF2F00"/>
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.8621 6.55172C17.1952 6.55172 18.2758 5.47103 18.2758 4.13793C18.2758 2.80483 17.1952 1.72414 15.8621 1.72414C14.529 1.72414 13.4483 2.80483 13.4483 4.13793C13.4483 5.47103 14.529 6.55172 15.8621 6.55172ZM15.8621 8.27586C18.1474 8.27586 20 6.42325 20 4.13793C20 1.85261 18.1474 0 15.8621 0C13.5767 0 11.7241 1.85261 11.7241 4.13793C11.7241 6.42325 13.5767 8.27586 15.8621 8.27586Z"
                fill="#FF2F00"/>
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.8621 18.2758C17.1952 18.2758 18.2758 17.1952 18.2758 15.8621C18.2758 14.529 17.1952 13.4483 15.8621 13.4483C14.529 13.4483 13.4483 14.529 13.4483 15.8621C13.4483 17.1952 14.529 18.2758 15.8621 18.2758ZM15.8621 20C18.1474 20 20 18.1474 20 15.8621C20 13.5767 18.1474 11.7241 15.8621 11.7241C13.5767 11.7241 11.7241 13.5767 11.7241 15.8621C11.7241 18.1474 13.5767 20 15.8621 20Z"
                fill="#FF2F00"/>
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.13793 18.2758C5.47103 18.2758 6.55172 17.1952 6.55172 15.8621C6.55172 14.529 5.47103 13.4483 4.13793 13.4483C2.80483 13.4483 1.72414 14.529 1.72414 15.8621C1.72414 17.1952 2.80483 18.2758 4.13793 18.2758ZM4.13793 20C6.42325 20 8.27586 18.1474 8.27586 15.8621C8.27586 13.5767 6.42325 11.7241 4.13793 11.7241C1.85261 11.7241 0 13.5767 0 15.8621C0 18.1474 1.85261 20 4.13793 20Z"
                fill="#FF2F00"/>
        </svg>
      </span>
      <span class="header-catalog__text">
        {{ $t('up.menu.catalog') }}
      </span>
    </a>
    <nav class="header-catalog__nav catalog-nav">
      <ul class="catalog-nav__list">
        <li
          v-for="(item, idx) in catalog"
          :key="idx"
          class="catalog-nav__item catalog-nav__item--main"
        >
          <div class="catalog-nav__category">
            <span class="catalog-nav__icon">
              <img
                loading="lazy"
                data-force-load="true"
                :src="item.icon"
                :alt="item.name"
              >
            </span>
            <a class="catalog-nav__link" :href="item.full_url">{{ item.name }}</a>
          </div>
          <div class="catalog-nav__submenu catalog-submenu">
            <ul class="catalog-submenu__list">
              <li
                v-for="(item, idx) in item.items"
                :key="idx"
                class="catalog-submenu__item"
              >
                <a :href="item.full_url" class="catalog-submenu__link">
                  <div class="catalog-submenu__img-wrapper">
                    <img
                      :src="item.icon"
                      :alt="item.name"
                      loading="lazy"
                      data-force-load="true"
                      class="categories-submenu__thumb"
                    >
                  </div>
                  <div class="catalog-submenu__label">{{ item.name }}</div>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderCatalog',
  props: {
    catalog: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix'])
  }
}
</script>

<style scoped lang="sass">
.catalog-nav
  min-width: 260px

</style>
